import React from "react";
import { SummaryDataValues } from "../../../../../../Rest_api/RestApi";

interface SummaryTilesCurrentValuesProps {
    data?: SummaryDataValues;
}

const SummaryTilesCurrentValues: React.FC<SummaryTilesCurrentValuesProps> = ({
    data,
}) => {
    // Map API data to display format
    // Removed "Load" as requested
    const displayData = [
        { label: "Wg. Avg. MCP (Rs/MWh)", value: data?.avg_mcp?.toFixed(2) || "-", isPositive: true },
        { label: "MCV (MWh)", value: data?.mcv?.toFixed(2) || "-", isPositive: true },
        { label: "Avg. Buy Bid (MWh)", value: data?.avg_buy_bid?.toFixed(2) || "-", isPositive: false },
        { label: "Avg. Sell Bid (MWh)", value: data?.avg_sell_bid?.toFixed(2) || "-", isPositive: false },
        { label: "All India Demand (MWh)", value: data?.all_india_demand?.toFixed(2) || "-", isPositive: false },
        { label: "All India Generation (MWh)", value: data?.all_india_generation?.toFixed(2) || "-", isPositive: false },
        { label: "Peak Demand (MW)", value: data?.peak_demand?.toFixed(2) || "-", isPositive: false },
    ];

    return (
        <div className="flex items-stretch gap-2 w-full min-w-0">
            {/* Current Values Badge */}
            <div
                className="flex items-center justify-center px-2 py-2 rounded-lg border border-[#F1935C] text-[#F1935C] text-xs font-medium text-center leading-tight flex-shrink-0"
                style={{ backgroundColor: "#FFFAF6", minWidth: "110px" }}
            >
                Current Range<br />Values
            </div>

            {/* Values Cards */}
            <div className="flex items-stretch gap-2 flex-1 min-w-0">
                {displayData.map((item, index) => (
                    <div
                        key={index}
                        className="flex flex-col justify-center px-2 py-2 bg-white rounded-lg border border-[#DFEAF2] flex-1 min-w-0"
                    >
                        <div className="flex items-center gap-1 min-w-0">
                            <span className="text-[10px] text-[#F1935C] truncate">
                                {item.label}
                            </span>
                        </div>
                        <div
                            className={`text-sm font-semibold truncate text-[#2B3674]`}
                        >
                            {item.value}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SummaryTilesCurrentValues;
